var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { bem, useIsUserInteractionMode, useKeyboardFocus, } from "@react-md/utils";
import cn from "classnames";
import { useTabIndicatorStyles } from "./useTabIndicatorStyles";
var styles = bem("rmd-tabs");
/**
 * The `TabsList` component is the container for all the individual `Tab`s that
 * should be rendered. This handles adding an active indicator underneath the
 * active tab and animating it to the new location when a new tab becomes
 * active. It also handles the ability update which tab is selected when it has
 * been clicked or updated with keyboard movement.
 *
 * This should probably not be used outside of this package unless a custom
 * implementation is desired.
 */
export var TabsList = forwardRef(function TabsList(_a, ref) {
    var _b;
    var style = _a.style, className = _a.className, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, children = _a.children, activeIndex = _a.activeIndex, _c = _a.align, align = _c === void 0 ? "left" : _c, _d = _a.automatic, automatic = _d === void 0 ? false : _d, _e = _a.padded, padded = _e === void 0 ? false : _e, _f = _a.orientation, orientation = _f === void 0 ? "horizontal" : _f, onActiveIndexChange = _a.onActiveIndexChange, _g = _a.disableTransition, disableTransition = _g === void 0 ? false : _g, props = __rest(_a, ["style", "className", "onFocus", "onKeyDown", "children", "activeIndex", "align", "automatic", "padded", "orientation", "onActiveIndexChange", "disableTransition"]);
    var horizontal = orientation === "horizontal";
    var isKeyboard = useIsUserInteractionMode("keyboard");
    var _h = useKeyboardFocus({
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onFocusChange: function (element, focusIndex) {
            element.focus();
            if (automatic) {
                onActiveIndexChange(focusIndex);
            }
        },
    }), _focusIndex = _h.focusIndex, eventHandlers = __rest(_h, ["focusIndex"]);
    var _j = useTabIndicatorStyles({
        ref: ref,
        activeIndex: activeIndex,
    }), refCallback = _j.refCallback, indicatorStyles = _j.indicatorStyles;
    return (_jsx("div", __assign({}, props, { "aria-orientation": orientation, style: __assign(__assign({}, style), indicatorStyles), role: "tablist", ref: refCallback, className: cn(styles((_b = {},
            _b[align] = true,
            _b.padded = padded,
            _b.vertical = !horizontal,
            _b.animate = !disableTransition && (!automatic || !isKeyboard),
            _b)), className) }, eventHandlers, { children: children })));
});
//# sourceMappingURL=TabsList.js.map